import React from 'react';
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Divider from "@material-ui/core/Divider";
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
    listItemProducts: {
        justifyContent: 'space-between',
    },
    chip: {
        margin: theme.spacing(0.5),
        fontSize: '0.75rem',
        height: '24px',
    },
    chipContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: theme.spacing(0.5),
    }
}));

const ProductListItem = ({ product }) => {
    const classes = useStyles();
    
    return (
        <>
            <ListItem
                button
                className={classes.listItemProducts}
                component={(props) => <Link to={{ pathname: `/product/${product.id}`, productid: `${product.id}` }} {...props} />}
            >
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={8}>
                                <Typography variant="body1" gutterBottom>
                                    <strong>{product.code}</strong>
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    {product.description}
                                </Typography>
                                <div className={classes.chipContainer}>
                                    {product.type && (
                                        <Chip 
                                            label={product.type} 
                                            size="small" 
                                            variant="outlined" 
                                            className={classes.chip}
                                        />
                                    )}
                                    {product.style && (
                                        <Chip 
                                            label={product.style} 
                                            size="small" 
                                            variant="outlined" 
                                            className={classes.chip}
                                        />
                                    )}
                                    {product.species && (
                                        <Chip 
                                            label={product.species} 
                                            size="small" 
                                            variant="outlined" 
                                            className={classes.chip}
                                        />
                                    )}
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="caption" align="right">
                                    {product.brand && `Brand: ${product.brand}`}
                                </Typography>
                                <br />
                                <Typography variant="caption" align="right">
                                    {product.supplier && `Supplier: ${product.supplier}`}
                                </Typography>
                                <br />
                                <Typography variant="caption" align="right">
                                    {product.uom && `UOM: ${product.uom}`}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
            <Divider />
        </>
    );
}

export default ProductListItem
